import { useMemo } from "react"

import { TeamMember } from "../types/TeamMember"

interface UseTeamMemberArgs {
  email: string | null | undefined
  teamMembers: TeamMember[] | null | undefined
}

export function useTeamMemberByEmail({
  email,
  teamMembers
}: UseTeamMemberArgs) {
  return useMemo(() => {
    if (email && teamMembers) {
      return (
        teamMembers.find(
          member => member.user?.email.toLowerCase() === email.toLowerCase()
        ) || null
      )
    }
    return null
  }, [email, teamMembers])
}
